<template>
  <div style="margin-top: 70px;">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 12 : 2" outlined width="100%">
                <div
                  v-if="
                    isAuthenticated &&
                      (hasRole('ROLE_HR_REFERENT') || hasRole('ROLE_ADMIN'))
                  "
                >
                  <Dashboard />
                </div>
                <div v-else>
                  <v-img
                    height="400px"
                    class="white--text align-end"
                    src="../assets/banniereEuropcarHome.png"
                  >
                    <v-card-title>{{ $t("home.homeTitle") }}</v-card-title>
                  </v-img>
                </div>

                <v-card-text v-html="labels['HOME_' + locale.toUpperCase()]">
                </v-card-text>
                <v-divider class="mx-4"></v-divider>
                <v-card-title>Documents</v-card-title>
                <v-card-text>
                  <p v-for="url in home.urls" v-bind:key="url.id">
                    <a :href="url.href" target="_blank"> {{ url.text }}</a>
                  </p>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style></style>

<script>
import { mapGetters } from "vuex";
import refreshAuthentication from "@/utils/authentication.js";
import Dashboard from "../components/Dashboard.vue";

export default {
  name: "home",
  data() {
    return {
      text: "default",
      urls: [],
      langueJson: null,
      tmpLang: false,
    };
  },
  async created() {
    this.langueJson = await import("../locales/" +
      this.user.langue.toLowerCase() +
      ".json");
    this.getData();
  },
  mounted: function() {
    this.getData();
    this.$store.dispatch("showUser");
    refreshAuthentication(this.$store);
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === "setLocale") {
        this.getData();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    ...mapGetters({
      home: "getHome",
      labels: "getLabels",
      user: "auth/user",
      locale: "getLocale",
      isAuthenticated: "auth/isAuthenticated",
      userRoles: "auth/userRoles",
    }),
  },
  methods: {
    hasRole: function(value) {
      if (this.isAuthenticated && this.userRoles) {
        var userHasRole = false;
        this.userRoles.forEach(function(currentRole) {
          if (currentRole === value) {
            userHasRole = true;
          }
        });
        return userHasRole;
      }
    },
    getData: function() {
      if (!this.labels || Object.keys(this.labels).length <= 0) {
        fetch(process.env.VUE_APP_ROOT_API_PATH + "api-public/ref/labels", {
          method: "GET",
          credentials: "include",
        })
          .then((response) => {
            if (response.status == "200") {
              return response.json();
            }
            return;
          })
          .then((json) => {
            if (json) {
              this.$store.dispatch("loadLabels", json.data);
            }
          });
      }
      // if (!this.home.text || this.home.text === "") {
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api-public/ref/home/" +
          this.locale.toUpperCase(),
        {
          method: "GET",
          credentials: "include",
        }
      )
        .then((response) => {
          if (response.status == "200") {
            return response.json();
          }
          return;
        })
        .then((json) => {
          if (json) {
            this.initializeLabels(json.data.label);
            this.$store.dispatch("loadHomeData", {
              text: json.data.label,
              urls: json.data.urls,
            });
          }
        });
    },
    initializeLabels(homeLabels) {
      this.langueJson.home.homeText = homeLabels;
    },
  },
  components: { Dashboard },
};
</script>
